import React, { Component } from 'react';
import fetch from '../../support/fetch';
import AuthenticatedTemplate from "../../Components/Templates/Authenticated/index";
import { Card, Grid, Dimmer, Form, Button } from 'tabler-react';
import Input from '../../Components/Playgrond/Input';
import CardAlert from '../../Components/CardAlert';

class ChangePhone extends Component {
    state = {
        showLoader: false,
        alertText: '',
        alertColor: 'danger',
        user: {},
        values: {}
    };

    componentDidMount() {
        this.setState({
            user: JSON.parse(sessionStorage.getItem('ooppah_user_info'))
        })
    };

    onChangeHandler = e => {
        this.setState(prevState => ({
            values: {
                ...prevState.values,
                [e.target.name]: e.target.value
            }
        }))
    };

    submitHandler = e => {
        e.preventDefault();

        this.setState({showLoader: true});
        const formData = {
            new_phone: this.state.values.new_phone,
            new_phone_confirmation: this.state.values.new_phone_confirmation,
        };
        if (formData.new_phone !== formData.new_phone_confirmation) {
            const msg = 'Novo Telefone e Novo Telefone - Confirmação estão com valores diferentes';
            this.setState({
                alertText: msg
            });
            this.setState({showLoader: false});
            return false;
        }

        fetch.obj({
            query: `mutation ChangePhone($new_phone: String!, $new_phone_confirmation: String!) {
                changePhone(new_phone: $new_phone, new_phone_confirmation: $new_phone_confirmation) {
                    id
                    phone
                }
            }`,
            variables: formData
        })
        .then(res => {
            if (res.hasOwnProperty('errors') && res.errors[0].hasOwnProperty('validation')) {
                const lastErrorKey = Object.keys(res.errors[0].validation)[0];

                this.setState({
                    alertText: res.errors[0].validation[lastErrorKey][0]
                })
            }

            this.setState(prevState => ({
                user: {
                    ...prevState.user,
                    phone: this.state.values.new_phone
                }
            }), () => {
                sessionStorage.setItem('ooppah_user_info', JSON.stringify(this.state.user));
                window.location = '/home'
            });
            this.setState({showLoader: false});
        });
    };

    render() {
        return (
            <AuthenticatedTemplate title="Alterar Telefone">
                <Grid.Row>
                    <Grid.Col md="7">
                        <form method="POST" onSubmit={this.submitHandler} autoComplete="off">
                            <Card>
                                <Card.Body>
                                    <CardAlert color={this.state.alertColor} >{this.state.alertText}</CardAlert>
                                    <Dimmer active={this.state.loading} loader={this.state.loading}>
                                        <p className="lead">
                                            Informe o telefone que você gostaria de utilizar para receber os{' '}
                                            Contatos que o Ooppah poderá fazer.
                                        </p>
                                        <Form.Group label="Novo Telefone">
                                            <Input
                                                name="new_phone"
                                                type="text"
                                                required
                                                onChange={this.onChangeHandler}
                                                disabled={this.state.showLoader}
                                            />
                                        </Form.Group>

                                        <Form.Group label="Novo Telefone - Confirmação">
                                            <Input
                                                name="new_phone_confirmation"
                                                type="text"
                                                required
                                                onChange={this.onChangeHandler}
                                                disabled={this.state.showLoader}
                                            />
                                        </Form.Group>

                                        <Button
                                            outline={!this.state.showLoader}
                                            color="info"
                                            block size="lg"
                                            className="mt-6"
                                            loading={this.state.showLoader}
                                            disabled={this.state.showLoader}
                                        >
                                            Alterar meu Telefone
                                        </Button>
                                    </Dimmer>
                                </Card.Body>
                            </Card>
                        </form>
                    </Grid.Col>
                </Grid.Row>
            </AuthenticatedTemplate>
        );
    }
}

export default ChangePhone;
